import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Users, Lock } from 'lucide-react';

const PrivacySelector = ({ currentTheme, privacy, onPrivacyChange, t }) => {
  const privacyOptions = [
    { 
      id: 'general', 
      icon: Globe, 
      label: t('identityCircle.privacy.general', 'General'),
      description: t('identityCircle.privacy.generalDesc', 'Visible to all connections')
    },
    { 
      id: 'circle', 
      icon: Users, 
      label: t('identityCircle.privacy.circle', 'Circle'),
      description: t('identityCircle.privacy.circleDesc', 'Only close circle')
    },
    { 
      id: 'selected', 
      icon: Lock, 
      label: t('identityCircle.privacy.selected', 'Selected'),
      description: t('identityCircle.privacy.selectedDesc', 'Choose who can see')
    }
  ];

  return (
    <div className="space-y-2">
      <h3 className={`text-sm font-medium ${currentTheme.textPrimary} mb-3`}>
        {t('identityCircle.privacy.title', 'Privacy Setting')}
      </h3>
      <div className="space-y-2">
        {privacyOptions.map(option => {
          const Icon = option.icon;
          const isSelected = privacy === option.id;
          
          return (
            <motion.button
              key={option.id}
              onClick={() => onPrivacyChange(option.id)}
              className={`w-full flex items-center space-x-3 p-3 rounded-lg border transition-all ${
                isSelected 
                  ? `${currentTheme.accent} text-white border-transparent` 
                  : `${currentTheme.cardBg} ${currentTheme.border} ${currentTheme.hover}`
              }`}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <Icon size={20} />
              <div className="flex-1 text-left">
                <p className={`font-medium ${isSelected ? 'text-white' : currentTheme.textPrimary}`}>
                  {option.label}
                </p>
                <p className={`text-xs ${isSelected ? 'text-white/80' : currentTheme.textSecondary}`}>
                  {option.description}
                </p>
              </div>
              {isSelected && (
                <div className="w-2 h-2 bg-white rounded-full" />
              )}
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default PrivacySelector;
